export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00281.f64bcb90.png";